import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// landIeul: components/uiParts/PropertyLocalNavigation/index.tsx の react-scroll 相当。
// クリックで対象 id へスムーススクロール (offset -70)。
class SitePrefectureAreaPropertyLocalNavigationController extends Controller {
  scrollTo(e: Event & { params: { target: string } }): void {
    e.preventDefault();
    const el = document.getElementById(e.params.target);
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.scrollY - 70;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}

application.register(
  "site--prefecture-area--property-local-navigation",
  SitePrefectureAreaPropertyLocalNavigationController,
);
